import classicLearning from "./assets/images/home/classic_learning.png";
import coursewares from "./assets/images/home/coursewares.png";
import digitalCourses from "./assets/images/home/digital_courses.png";
import vidoes from "./assets/images/home/vidoes.png";
import supportServices from "./assets/images/home/support_services.png";
import placeholder from "./assets/images/home/placeholder.png";
import classicLearningHover from "./assets/images/home/classic_learning_hover.png";
import coursewaresHover from "./assets/images/home/coursewares_hover.png";
import digitalCoursesHover from "./assets/images/home/digital_courses_hover.png";
import vidoesHover from "./assets/images/home/vidoes_hover.png";
import supportServicesHover from "./assets/images/home/support_services_hover.png";
import placeholderHover from "./assets/images/home/placeholder_hover.png";
import gefen from "./assets/images/home/gefen.png";
import gefenHover from "./assets/images/home/gefen_hover.png";

export const pages = [
  { linkTo: '/', text: 'pages.homepage', image: placeholder, hoverImage: placeholderHover }
  , { linkTo: '/coursewares', text: 'pages.coursewares', image: coursewares, hoverImage: coursewaresHover }
  , { linkTo: '/vidoes', text: 'pages.vidoes', image: vidoes, hoverImage: vidoesHover }
  , { linkTo: '/digital-courses', text: 'pages.digital courses', image: digitalCourses, hoverImage: digitalCoursesHover }
  , { linkTo: '/classic-learning', text: 'pages.classic learning', image: classicLearning, hoverImage: classicLearningHover }
  , { linkTo: '/support-services', text: 'pages.support services', image: supportServices, hoverImage: supportServicesHover }
  , { linkTo: '/gefen', text: 'pages.gefen', image: gefen, hoverImage: gefenHover }, { linkTo: '/about', text: 'pages.who we are', image: placeholder, hoverImage: placeholderHover }
  , { linkTo: '/contact-us', text: 'pages.talk-with-us', image: placeholder, hoverImage: placeholderHover }
  , { linkTo: '/privacy-policy', text: 'pages.privacy policy', image: placeholder, hoverImage: placeholderHover }
  , { linkTo: '/term-of-use', text: 'pages.term-of-use', image: placeholder, hoverImage: placeholderHover }
]


export const routeVariants = {
  final: {
    clipPath: `circle(${10000}% at 80% 100vh)`,
    backgroundColor: 'transperent',
    transition: {
      delay: 0.5,
      type: "spring",
      stiffness: 20,
      restDelta: 2,
      damping: 400,
    },
  },
  initial: {
    clipPath: "circle(0px at 40px 40px)",
    backgroundColor: 'red',
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 40,
    },
  },
};

export const childVariants = {
  initial: {
    opacity: 0,
    y: "50px",
  },
  final: {
    opacity: 1,
    y: "0px",
    transition: {
      duration: 0.5,
      delay: 0.5,
    },
  },
};